import appConfig from '@/config/global-config'
import { createNavigation } from 'next-intl/navigation'
import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
  locales: appConfig.locales,
  defaultLocale: appConfig.defaultLocale,
  localePrefix: {
    mode: 'never',
  },
  pathnames: {
    '/products': {
      en: '/products',
      vi: '/san-pham',
    },
    '/news': {
      en: '/news',
      vi: '/tin-tuc',
    },
    '/help': {
      en: '/help',
      vi: '/trung-tam-ho-tro',
    },
    '/cart': {
      en: '/cart',
      vi: '/gio-hang',
    },
    '/order-lookup': {
      en: '/order-lookup',
      vi: '/tra-cuu-don-hang',
    },
  },
})
export const { Link, redirect, usePathname, useRouter } = createNavigation(routing)
export type TypeLink = Parameters<typeof Link>[0]['href']
